var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _g, _path125, _path126, _path127, _path128, _path129, _g2, _g3, _g4, _g5, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonEmergencyService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 55,
    viewBox: "0 0 126 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9071 48.2075H103.273L105.296 48.0519C105.296 48.0519 106.042 37.8464 96.1169 37.7842C86.1915 37.7531 86.9071 48.2075 86.9071 48.2075Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4241 48.7675H29.8748C29.8748 48.7675 29.8748 37.442 20.945 37.442C12.0463 37.4109 11.4241 45.4072 11.4241 48.7675Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.852 47.0562C27.852 42.9492 24.5228 39.62 20.4158 39.62C16.3087 39.62 12.9795 42.9492 12.9795 47.0562C12.9795 51.1633 16.3087 54.4925 20.4158 54.4925C24.5228 54.4925 27.852 51.1633 27.852 47.0562Z",
    fill: "url(#paint0_linear_334_30477)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.261 47.0562C27.261 43.2914 24.2118 40.2111 20.4159 40.2111C16.6511 40.2111 13.5708 43.2603 13.5708 47.0562C13.5708 50.8522 16.62 53.9013 20.4159 53.9013C24.2118 53.9013 27.261 50.821 27.261 47.0562Z",
    fill: "#3B4447"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.5501 47.0562C25.5501 44.2248 23.2477 41.9224 20.4163 41.9224C17.5849 41.9224 15.2825 44.2248 15.2825 47.0562C15.2825 49.8876 17.5849 52.1901 20.4163 52.1901C23.2477 52.1901 25.5501 49.8876 25.5501 47.0562Z",
    fill: "url(#paint1_linear_334_30477)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4157 51.5989C22.9246 51.5989 24.9584 49.5651 24.9584 47.0562C24.9584 44.5474 22.9246 42.5136 20.4157 42.5136C17.9069 42.5136 15.873 44.5474 15.873 47.0562C15.873 49.5651 17.9069 51.5989 20.4157 51.5989Z",
    fill: "url(#paint2_linear_334_30477)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6791 47.0562C24.6791 44.6916 22.7811 42.7625 20.4164 42.7625C18.0518 42.7625 16.1538 44.6916 16.1538 47.0562C16.1538 49.4209 18.0518 51.35 20.4164 51.35C22.7811 51.35 24.6791 49.4209 24.6791 47.0562Z",
    fill: "url(#paint3_linear_334_30477)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5941 47.0562C22.5941 45.8428 21.6295 44.8783 20.4472 44.8783C19.2648 44.8783 18.3003 45.8428 18.3003 47.0562C18.3003 48.2697 19.2648 49.2342 20.4472 49.2342C21.6295 49.2342 22.5941 48.2697 22.5941 47.0562Z",
    fill: "url(#paint4_linear_334_30477)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1586 47.0562C22.1586 46.0917 21.3808 45.3138 20.4162 45.3138C19.4517 45.3138 18.6738 46.0917 18.6738 47.0562C18.6738 48.0208 19.4517 48.7986 20.4162 48.7986C21.3808 48.7986 22.1586 48.0208 22.1586 47.0562Z",
    fill: "url(#paint5_linear_334_30477)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0335 47.0562C22.0335 46.185 21.3179 45.4383 20.4467 45.4383C19.5755 45.4383 18.8599 46.1539 18.8599 47.0562C18.8599 47.9586 19.5755 48.6742 20.4467 48.6742C21.3179 48.6742 22.0335 47.9274 22.0335 47.0562Z",
    fill: "url(#paint6_linear_334_30477)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7312 47.0562C19.7312 47.4607 20.0423 47.7719 20.4468 47.7719C20.8513 47.7719 21.1624 47.4607 21.1624 47.0562C21.1624 46.6517 20.8513 46.3406 20.4468 46.3406C20.0423 46.3406 19.7312 46.6517 19.7312 47.0562Z",
    fill: "url(#paint7_linear_334_30477)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9761 47.0562C20.9761 46.7451 20.7272 46.4962 20.416 46.4962C20.1049 46.4962 19.856 46.7451 19.856 47.0562C19.856 47.3674 20.1049 47.6163 20.416 47.6163C20.7272 47.6163 20.9761 47.3674 20.9761 47.0562Z",
    fill: "url(#paint8_linear_334_30477)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4158 44.5982C20.5091 44.5982 20.6025 44.5982 20.6958 44.5982L20.758 43.167C20.6647 43.167 20.5402 43.1359 20.4469 43.1359C20.3224 43.1359 20.2291 43.1359 20.1357 43.167L20.198 44.5982C20.2602 44.5982 20.3224 44.5982 20.4158 44.5982Z",
    fill: "#393B3D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.825 44.6605L19.3894 43.2914C19.1716 43.3537 18.9849 43.4159 18.7671 43.5092L19.3272 44.816C19.5138 44.7849 19.6694 44.7227 19.825 44.6605Z",
    fill: "#393B3D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0468 45.0027L18.1756 43.8826C17.9889 44.0071 17.8333 44.1626 17.6777 44.2871L18.6423 45.345C18.7667 45.2205 18.9223 45.1272 19.0468 45.0027Z",
    fill: "#393B3D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4557 45.625L17.2423 44.8471C17.1178 45.0338 17.0245 45.2205 16.9312 45.4072L18.2068 46.0606C18.2691 45.905 18.3313 45.7494 18.4557 45.625Z",
    fill: "#393B3D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1894 45.345L23.1539 44.2871C22.9984 44.1315 22.8428 44.0071 22.6561 43.8826L21.7849 45.0027C21.9405 45.1272 22.0649 45.2205 22.1894 45.345Z",
    fill: "#393B3D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.874 46.9007L24.2741 46.714C24.243 46.4962 24.2119 46.2784 24.1496 46.0606L22.7495 46.3717C22.8117 46.5273 22.8428 46.714 22.874 46.9007Z",
    fill: "#393B3D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0822 46.3717L16.6821 46.0606C16.6199 46.2784 16.5887 46.4962 16.5576 46.714L17.9578 46.9007C17.9889 46.714 18.02 46.5273 18.0822 46.3717Z",
    fill: "#393B3D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5049 44.8471L22.065 43.5403C21.8783 43.447 21.6605 43.3848 21.4427 43.3225L21.0071 44.6916C21.1938 44.7227 21.3493 44.7849 21.5049 44.8471Z",
    fill: "#393B3D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6561 46.0606L23.9318 45.4072C23.8385 45.2205 23.7451 45.0338 23.6207 44.8471L22.4072 45.625C22.5006 45.7494 22.5939 45.905 22.6561 46.0606Z",
    fill: "#393B3D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4072 48.4875L23.6207 49.2653C23.7451 49.0787 23.8385 48.892 23.9318 48.7053L22.6561 48.0519C22.5939 48.2075 22.5006 48.363 22.4072 48.4875Z",
    fill: "#393B3D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9892 47.2118L16.5891 47.3985C16.6202 47.6163 16.6513 47.8341 16.7136 48.0519L18.1137 47.7407C18.0204 47.5852 17.9892 47.3985 17.9892 47.2118Z",
    fill: "#393B3D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7849 49.1098L22.6561 50.2299C22.8428 50.1054 22.9984 49.9499 23.1539 49.8254L22.1894 48.7675C22.0649 48.892 21.9405 48.9853 21.7849 49.1098Z",
    fill: "#393B3D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7808 47.7407L24.1809 48.0519C24.2431 47.8341 24.2742 47.6163 24.3054 47.3985L22.9052 47.2118C22.843 47.3985 22.8119 47.5852 22.7808 47.7407Z",
    fill: "#393B3D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0071 49.452L21.4427 50.821C21.6605 50.7588 21.8472 50.6966 22.065 50.6032L21.5049 49.2965C21.3493 49.3276 21.1938 49.3898 21.0071 49.452Z",
    fill: "#393B3D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1756 48.0519L16.8999 48.7053C16.9932 48.892 17.0866 49.0787 17.211 49.2653L18.4245 48.4875C18.3312 48.363 18.2689 48.2075 18.1756 48.0519Z",
    fill: "#393B3D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6423 48.7675L17.6777 49.8254C17.8333 49.981 17.9889 50.1054 18.1756 50.2299L19.0468 49.1098C18.9223 48.9853 18.7667 48.892 18.6423 48.7675Z",
    fill: "#393B3D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.416 49.5143C20.3227 49.5143 20.2293 49.5143 20.136 49.5143L20.0737 50.9455C20.1671 50.9455 20.2915 50.9766 20.3849 50.9766C20.5093 50.9766 20.6027 50.9766 20.696 50.9455L20.6338 49.5143C20.6027 49.5143 20.5093 49.5143 20.416 49.5143Z",
    fill: "#393B3D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3272 49.2653L18.7671 50.6032C18.9538 50.6966 19.1716 50.7588 19.3894 50.821L19.825 49.452C19.6694 49.3898 19.5138 49.3276 19.3272 49.2653Z",
    fill: "#393B3D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M103.366 47.0562C103.366 42.9492 100.037 39.62 95.9299 39.62C91.8229 39.62 88.4937 42.9492 88.4937 47.0562C88.4937 51.1633 91.8229 54.4925 95.9299 54.4925C100.037 54.4925 103.366 51.1633 103.366 47.0562Z",
    fill: "url(#paint9_linear_334_30477)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M102.775 47.0562C102.775 43.2914 99.726 40.2111 95.9301 40.2111C92.1653 40.2111 89.085 43.2603 89.085 47.0562C89.085 50.8522 92.1341 53.9013 95.9301 53.9013C99.726 53.9013 102.775 50.821 102.775 47.0562Z",
    fill: "#3B4447"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.064 47.0562C101.064 44.2248 98.7619 41.9224 95.9305 41.9224C93.0991 41.9224 90.7966 44.2248 90.7966 47.0562C90.7966 49.8876 93.0991 52.1901 95.9305 52.1901C98.7619 52.1901 101.064 49.8876 101.064 47.0562Z",
    fill: "url(#paint10_linear_334_30477)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9299 51.5989C98.4387 51.5989 100.473 49.5651 100.473 47.0562C100.473 44.5474 98.4387 42.5136 95.9299 42.5136C93.421 42.5136 91.3872 44.5474 91.3872 47.0562C91.3872 49.5651 93.421 51.5989 95.9299 51.5989Z",
    fill: "url(#paint11_linear_334_30477)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.193 47.0562C100.193 44.6916 98.2948 42.7625 95.9301 42.7625C93.5654 42.7625 91.6675 44.6916 91.6675 47.0562C91.6675 49.4209 93.5654 51.35 95.9301 51.35C98.2948 51.35 100.193 49.4209 100.193 47.0562Z",
    fill: "url(#paint12_linear_334_30477)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1082 47.0562C98.1082 45.8428 97.1436 44.8783 95.9613 44.8783C94.779 44.8783 93.8145 45.8428 93.8145 47.0562C93.8145 48.2697 94.779 49.2342 95.9613 49.2342C97.1436 49.2342 98.1082 48.2697 98.1082 47.0562Z",
    fill: "url(#paint13_linear_334_30477)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6725 47.0562C97.6725 46.0917 96.8947 45.3138 95.9301 45.3138C94.9656 45.3138 94.1877 46.0917 94.1877 47.0562C94.1877 48.0208 94.9656 48.7986 95.9301 48.7986C96.8947 48.7986 97.6725 48.0208 97.6725 47.0562Z",
    fill: "url(#paint14_linear_334_30477)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9301 48.6742C96.8065 48.6742 97.5169 47.9498 97.5169 47.0562C97.5169 46.1627 96.8065 45.4383 95.9301 45.4383C95.0537 45.4383 94.3433 46.1627 94.3433 47.0562C94.3433 47.9498 95.0537 48.6742 95.9301 48.6742Z",
    fill: "url(#paint15_linear_334_30477)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2456 47.0562C95.2456 47.4607 95.5567 47.7719 95.9612 47.7719C96.3657 47.7719 96.6768 47.4607 96.6768 47.0562C96.6768 46.6517 96.3657 46.3406 95.9612 46.3406C95.5567 46.3406 95.2456 46.6517 95.2456 47.0562Z",
    fill: "url(#paint16_linear_334_30477)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4902 47.0562C96.4902 46.7451 96.2413 46.4962 95.9301 46.4962C95.619 46.4962 95.3701 46.7451 95.3701 47.0562C95.3701 47.3674 95.619 47.6163 95.9301 47.6163C96.2413 47.6163 96.4902 47.3674 96.4902 47.0562Z",
    fill: "url(#paint17_linear_334_30477)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9299 44.5982C96.0233 44.5982 96.1166 44.5982 96.21 44.5982L96.2722 43.167C96.1788 43.167 96.0544 43.1359 95.961 43.1359C95.8366 43.1359 95.7432 43.1359 95.6499 43.167L95.7122 44.5982C95.7433 44.5982 95.8366 44.5982 95.9299 44.5982Z",
    fill: "#393B3D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3391 44.6605L94.9035 43.2914C94.6857 43.3537 94.499 43.4159 94.2812 43.5092L94.8413 44.816C94.9969 44.7849 95.1835 44.7227 95.3391 44.6605Z",
    fill: "#393B3D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5609 45.0027L93.6897 43.8826C93.503 44.0071 93.3475 44.1626 93.1919 44.2871L94.1564 45.345C94.2809 45.2205 94.4364 45.1272 94.5609 45.0027Z",
    fill: "#393B3D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9699 45.625L92.7565 44.8471C92.632 45.0338 92.5387 45.2205 92.4453 45.4072L93.721 46.0606C93.7521 45.905 93.8455 45.7494 93.9699 45.625Z",
    fill: "#393B3D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7036 45.345L98.6681 44.2871C98.5125 44.1315 98.357 44.0071 98.1703 43.8826L97.2991 45.0027C97.4546 45.1272 97.5791 45.2205 97.7036 45.345Z",
    fill: "#393B3D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3881 46.9007L99.7883 46.714C99.7572 46.4962 99.726 46.2784 99.6638 46.0606L98.2637 46.3717C98.3259 46.5273 98.357 46.714 98.3881 46.9007Z",
    fill: "#393B3D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5964 46.3717L92.1962 46.0606C92.134 46.2784 92.1029 46.4962 92.0718 46.714L93.4719 46.9007C93.503 46.714 93.5341 46.5273 93.5964 46.3717Z",
    fill: "#393B3D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0191 44.8471L97.5791 43.5403C97.3924 43.447 97.1746 43.3848 96.9568 43.3225L96.5212 44.6916C96.7079 44.7227 96.8635 44.7849 97.0191 44.8471Z",
    fill: "#393B3D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1703 46.0606L99.446 45.4072C99.3526 45.2205 99.2593 45.0338 99.1348 44.8471L97.9214 45.625C98.0147 45.7494 98.1081 45.905 98.1703 46.0606Z",
    fill: "#393B3D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9214 48.4875L99.1348 49.2653C99.2593 49.0787 99.3526 48.892 99.446 48.7053L98.1703 48.0519C98.1081 48.2075 98.0147 48.363 97.9214 48.4875Z",
    fill: "#393B3D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5034 47.2118L92.1033 47.3985C92.1344 47.6163 92.1655 47.8341 92.2277 48.0519L93.6278 47.7407C93.5345 47.5852 93.5034 47.3985 93.5034 47.2118Z",
    fill: "#393B3D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2991 49.1098L98.1703 50.2299C98.357 50.1054 98.5125 49.9499 98.6681 49.8254L97.7036 48.7675C97.5791 48.892 97.4546 48.9853 97.2991 49.1098Z",
    fill: "#393B3D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2949 47.7407L99.6951 48.0519C99.7573 47.8341 99.7884 47.6163 99.8195 47.3985L98.4194 47.2118C98.3572 47.3985 98.326 47.5852 98.2949 47.7407Z",
    fill: "#393B3D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5212 49.452L96.9568 50.821C97.1746 50.7588 97.3613 50.6966 97.5791 50.6032L97.0191 49.2965C96.8635 49.3276 96.7079 49.3898 96.5212 49.452Z",
    fill: "#393B3D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6897 48.0519L92.4141 48.7053C92.5074 48.892 92.6007 49.0787 92.7252 49.2653L93.9386 48.4875C93.8453 48.363 93.752 48.2075 93.6897 48.0519Z",
    fill: "#393B3D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1564 48.7675L93.1919 49.8254C93.3475 49.981 93.503 50.1054 93.6897 50.2299L94.5609 49.1098C94.4364 48.9853 94.2809 48.892 94.1564 48.7675Z",
    fill: "#393B3D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9301 49.5143C95.8368 49.5143 95.7434 49.5143 95.6501 49.5143L95.5879 50.9455C95.6812 50.9455 95.8057 50.9766 95.899 50.9766C96.0235 50.9766 96.1168 50.9766 96.2102 50.9455L96.148 49.5143C96.1168 49.5143 96.0235 49.5143 95.9301 49.5143Z",
    fill: "#393B3D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8413 49.2653L94.2812 50.6032C94.4679 50.6966 94.6857 50.7588 94.9035 50.821L95.3391 49.452C95.1835 49.3898 94.9969 49.3276 94.8413 49.2653Z",
    fill: "#393B3D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M124.96 44.0382H124.649V39.1844L124.991 38.531C124.991 38.531 124.897 28.8856 124.897 28.4189C124.897 27.9522 123.995 14.5108 123.56 11.4617C123.124 8.41247 122.004 4.52321 121.662 3.93204C121.319 3.37198 117.43 3.24753 116.31 3.21641C115.19 3.1853 89.1162 3.21641 89.1162 3.21641L51.3747 3.55867C51.3747 3.55867 47.5166 3.6209 43.9073 4.58543C40.267 5.54997 36.7511 7.35459 31.1194 12.6751V12.9863L17.8959 26.552H15.5312C15.5312 26.552 6.07252 30.908 5.07687 31.5303C4.08121 32.1526 2.74331 32.9926 2.18325 34.3306L2.7122 34.4861L2.43216 35.5129L1.80988 35.9485L1.65431 36.4463H2.12102L1.87211 37.6287L1.24983 38.0643L1.1876 38.4687H1.6232L1.34317 39.62L0.720886 39.9V40.3667L0.969815 40.7712L0.658673 40.8334L0.316406 41.1757L0.347532 41.5801L1.4054 41.8602L1.37429 44.1937H1.09426C1.09426 44.1937 1.00092 45.3761 1.15649 45.905C1.31206 46.4028 1.43652 46.994 2.15215 47.274C2.89889 47.5541 5.41913 48.5186 5.41913 48.5186L5.82361 48.9231H11.5797C11.5797 42.3891 15.7179 38.3443 20.4784 38.3443C24.7721 38.3443 28.3503 41.4868 29.0037 45.5628L29.5015 48.892V49.2965L86.9382 48.6431H87.0315C87.1249 42.2647 91.2008 38.3132 95.9302 38.3132C100.224 38.3132 103.802 41.4557 104.455 45.5316L105.109 48.5497H105.202L118.332 47.3051L123.591 46.6517L123.715 46.434C123.715 46.434 124.68 46.4651 124.991 46.1228C125.302 45.8117 125.489 44.1937 125.489 44.1937L124.96 44.0382Z",
    fill: "#EEF5F9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9196 12.4262L36.0976 10.2793L34.5419 9.68816C33.764 10.3104 32.9239 11.0261 32.0527 11.835L33.9196 12.4262Z",
    fill: "#B61617"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0174 13.4841C79.346 13.4841 76.3901 16.4399 76.3901 20.1114C76.3901 23.7829 79.346 26.7387 83.0174 26.7387C86.6889 26.7387 89.6448 23.7829 89.6448 20.1114C89.6448 16.4399 86.6889 13.4841 83.0174 13.4841ZM83.0174 26.2409C79.6571 26.2409 76.9191 23.5028 76.9191 20.1425C76.9191 16.7822 79.6571 14.0441 83.0174 14.0441C86.3778 14.0441 89.1158 16.7822 89.1158 20.1425C89.1469 23.5028 86.4089 26.2409 83.0174 26.2409Z",
    fill: "#0080FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8713 18.8357L86.5956 16.6577L84.2932 17.9956V15.3198H81.773V17.9956L79.4394 16.6577L78.1948 18.8357L80.4973 20.1736L78.1948 21.5115L79.4394 23.6895L81.773 22.3516V25.0274H84.2932V22.3516L86.5956 23.6895L87.8713 21.5115L85.5378 20.1736L87.8713 18.8357Z",
    fill: "#0080FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1623 41.2379C15.8114 39.3399 18.0516 38.3132 20.4785 38.3132C23.061 38.3132 25.3945 39.4333 26.9814 41.2379H78.1952H89.6142C91.2632 39.3399 93.5034 38.3132 95.9303 38.3132C98.5128 38.3132 100.846 39.4333 102.433 41.2379H119.857L123.497 39.2466H124.649H124.68V39.1844L125.022 38.531C125.022 38.531 124.991 35.1084 124.96 32.277L124.929 32.2459L123.622 30.9391L119.919 30.6591L73.8393 31.4058L48.4812 33.0238L29.875 35.2329L7.78393 36.1974H1.74779L1.68556 36.4463H2.15227L1.90336 37.6286L1.28108 38.0642L1.21885 38.4687H1.65444L1.37442 39.62L0.752136 39.9V40.3667L1.00105 40.7712L0.689904 40.8334L0.347656 41.1757V41.269H14.1623V41.2379Z",
    fill: "#B61617"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M122.346 7.66574H117.741L73.7455 7.41682C73.7455 7.41682 51.2811 7.85242 48.3253 7.85242C46.6451 7.85242 40.9823 8.78585 40.9823 8.78585C40.9823 8.78585 38.5865 9.3459 36.8753 11.0883C35.9418 12.0528 35.2573 13.1107 35.2573 13.1107C38.8666 11.5861 48.3253 11.1816 48.3253 11.1816L73.8389 10.8394L122.968 10.9327L122.346 7.66574Z",
    fill: "#B61617"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.875 27.8277C122.564 22.2583 120.915 7.01233 120.666 5.58108C120.417 4.14983 118.395 4.46097 118.395 4.46097L64.6295 4.741C61.8914 4.741 46.3032 4.55432 42.5384 6.63896C38.8047 8.75473 33.4842 13.1107 33.4842 13.1107L32.3019 13.8886C32.3019 13.8886 20.7896 26.2409 19.4206 26.6142C18.0516 26.9876 11.2376 30.1613 9.77524 30.8769C8.31287 31.5925 6.66382 32.8993 6.66382 32.8993V33.2727L2.99236 38.4687L2.18338 39.62L1.37442 39.5266L0.752136 39.8066V40.2733L1.00105 40.6778L0.689904 40.7401L0.347656 41.0823L0.378763 41.4868L1.43665 41.7668L1.40553 44.1004H1.12551C1.12551 44.1004 1.03215 45.2827 1.18772 45.8117C1.34329 46.3095 1.46775 46.9007 2.18338 47.1807C2.93012 47.4607 5.45036 48.4253 5.45036 48.4253L5.85484 48.8297H11.5799C11.5799 42.2958 15.718 38.2509 20.4785 38.2509C24.7722 38.2509 28.3504 41.3935 29.0038 45.4694L29.3149 47.5541L48.4812 47.2429L87.125 46.9318C87.8406 41.549 91.6054 38.282 95.8992 38.282C100.193 38.282 103.771 41.4246 104.424 45.5005L104.736 46.9007L118.27 45.8117L118.301 46.9007L104.984 48.1141L105.078 48.5186H105.171L118.301 47.274L122.875 46.714C122.968 42.918 123.124 32.3392 122.875 27.8277ZM48.2945 11.1816L73.8081 10.8394L119.017 10.9327V11.3683L73.7459 11.275L48.3256 11.6795H47.3922C47.3922 11.6795 39.4892 12.3017 37.7468 12.5818L35.2577 13.1418C38.8358 11.6172 48.2945 11.1816 48.2945 11.1816ZM51.1882 24.3118C50.5348 20.5781 50.5036 16.0977 50.3792 14.7909C50.3792 14.7909 50.1614 12.6129 51.8727 12.6129C53.8329 12.6129 73.777 12.3329 73.777 12.3329L114.848 12.3017C114.848 12.3017 117.275 12.6129 117.586 14.7598C117.897 16.9066 118.799 24.7785 118.893 25.9608C118.986 27.1432 118.737 27.5788 117.897 27.5788C117.026 27.5788 73.8392 27.9833 73.8392 27.9833C73.8392 27.9833 56.5087 28.3877 54.9841 28.3877C53.3973 28.3877 51.8416 28.0455 51.1882 24.3118ZM25.4568 30.099C17.8649 31.5303 10.522 33.366 10.522 33.366L10.4286 32.9304L21.5053 29.7257L41.3872 24.2185L45.3387 13.3596C45.3387 13.3596 46.0543 13.4218 46.2099 14.0441C46.3655 14.6664 46.0543 18.649 45.6498 21.5738C45.2454 24.4674 45.5565 26.3964 41.4183 27.4232C39.427 27.8899 32.333 28.7922 25.4568 30.099ZM44.063 30.2857C44.063 31.0325 43.4718 31.6236 42.7251 31.6236C41.9784 31.6236 41.3872 31.0325 41.3872 30.2857C41.3872 29.539 41.9784 28.9478 42.7251 28.9478C43.4718 28.9789 44.063 29.5701 44.063 30.2857ZM120.044 31.3125V33.2727L73.9015 33.7705L48.5435 34.5483L29.7816 35.2329L48.5435 33.0238L73.9015 31.4058L120.044 30.6591V31.3125Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M54.9525 28.0766C53.4901 28.0766 52.1211 27.7966 51.4988 24.2496C51.0632 21.6049 50.9077 18.6179 50.7832 16.6266C50.7521 15.7865 50.721 15.1331 50.6587 14.7598C50.6587 14.7598 50.5654 13.7641 51.0321 13.2352C51.2188 13.0174 51.4988 12.924 51.8411 12.924C53.7702 12.924 73.4965 12.644 73.7455 12.644L114.785 12.6129C115.003 12.644 116.963 12.9863 117.243 14.822C117.554 17.0933 118.456 24.8719 118.55 25.992C118.612 26.6142 118.55 26.9565 118.394 27.1121C118.332 27.1743 118.208 27.2676 117.834 27.2676C116.994 27.2676 74.2433 27.6721 73.7766 27.6721C73.5899 27.7032 56.446 28.0766 54.9525 28.0766Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M105.015 48.1764L118.332 46.9629V46.0917L104.798 47.1496L105.015 48.1764Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.5121 48.4253L29.5325 48.8609V49.2653L86.9692 48.6119H87.0625C87.0625 48.4564 87.0625 48.3008 87.0936 48.1452L48.5121 48.4253Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.1251 47.274L48.5124 47.5852L29.3772 47.8963L29.5328 48.8609L48.5124 48.4253L87.0628 48.1764C87.0628 47.8652 87.0939 47.5852 87.1251 47.274Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.062 47.8341L48.5116 48.1452L29.4697 48.4564L29.532 48.8297L48.5116 48.3941L87.062 48.1452C87.062 48.083 87.062 47.9585 87.062 47.8341Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.6566 45.4383L29.9677 47.5852H30.31L29.9677 45.3761C29.8122 44.4738 29.5633 43.6337 29.1899 42.8558H28.7854C29.221 43.6648 29.501 44.536 29.6566 45.4383Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M86.2222 46.994H86.4711C86.6889 45.3138 87.1867 43.8204 87.9023 42.5758H87.6223C86.9067 43.8204 86.44 45.3138 86.2222 46.994Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.6071 26.5831L17.927 26.6142L17.8647 26.5831H15.5623C15.5623 26.5831 6.10359 30.9391 5.10793 31.5614C4.11228 32.1837 2.77438 33.0237 2.21432 34.3617L2.74325 34.5172L2.46323 35.544L1.84095 35.9796L1.68538 36.4774H2.15209L1.90318 37.6598L1.2809 38.0954L1.21867 38.4998H1.65425L1.37424 39.6511L0.751953 39.9311V40.2111L1.52981 40.0867C1.52981 40.0867 2.58768 36.9441 2.89882 36.1663C3.24107 35.3884 4.29895 32.9304 6.32137 31.997C8.34379 31.0013 19.6071 26.5831 19.6071 26.5831Z",
    fill: "url(#paint18_linear_334_30477)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.3016 13.9197L33.4839 13.1418C33.4839 13.1418 38.7733 8.78584 42.5381 6.67008C44.0627 5.83 47.5164 5.33217 51.2501 5.08326V3.58978C50.5345 3.6209 47.143 3.77647 43.9072 4.61655C40.2668 5.58109 36.7509 7.38571 31.1192 12.7062V13.0174L29.688 14.4797L31.4304 14.8531C31.9904 14.2619 32.3016 13.9197 32.3016 13.9197Z",
    fill: "url(#paint19_linear_334_30477)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.3697 13.3285C45.3697 13.3285 46.0853 13.3907 46.2409 14.013C46.3965 14.6353 46.0853 18.6179 45.6808 21.5426C45.2763 24.4363 45.5875 26.3653 41.4493 27.3921C39.458 27.8899 32.3951 28.7922 25.5189 30.0679C17.927 31.4992 10.5841 33.3349 10.5841 33.3349L10.4907 32.8993L21.5674 29.6945L41.4493 24.1873L45.3697 13.3285Z",
    fill: "url(#paint20_linear_334_30477)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.7812 35.2329L48.5119 33.0238L73.9011 31.4058L120.043 30.6591V31.3125L73.8078 31.9036L48.4808 33.4594L29.7812 35.2329Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.8079 10.8394L48.2943 11.1816C48.2943 11.1816 38.8356 11.6172 35.2263 13.1107L37.9333 12.4262C38.7733 12.3017 40.9513 12.0528 42.9737 11.835C45.2451 11.6172 47.3608 11.4305 47.3608 11.4305H48.2943L73.7145 11.0572L118.986 11.1505V10.9327L73.8079 10.8394Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.2946 7.60351C46.4277 7.63462 42.0407 8.22579 40.9517 8.78584C40.9517 8.78584 46.6144 7.85242 48.2946 7.85242C51.2816 7.85242 73.7148 7.41682 73.7148 7.41682L117.71 7.66574L73.6837 7.1368C73.6837 7.16791 55.8242 7.51016 48.2946 7.60351Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M120.261 39.7133L120.044 38.531H103.304C101.313 36.7886 98.7305 35.7307 95.8991 35.7307C93.0677 35.7307 90.423 36.8197 88.3695 38.811L28.7548 39.1844C26.6701 36.9753 23.7454 35.6062 20.4784 35.6062C17.2736 35.6062 14.2867 37.0064 12.1398 39.4955L1.28097 39.7133L1.09428 39.7444L0.783137 39.8689V40.3356L1.03205 40.7401L0.720904 40.8023L0.658691 40.8645L6.38368 40.4912H11.3619H11.9531C14.0378 37.6598 17.1181 36.1041 20.4784 36.1041C24.0565 36.1041 27.2302 37.8465 29.2215 40.4912H29.8126C29.8126 40.46 29.7815 40.46 29.7815 40.4289L81.431 40.2734V39.5888H88.3695C90.3608 37.442 93.0366 36.2596 95.9302 36.2596C98.9794 36.2596 101.717 37.5353 103.678 39.5888H109.869V39.9L120.261 39.7133Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.5183 31.4992C13.9445 32.4948 10.522 33.3349 10.522 33.3349L10.4286 32.8993L18.5183 30.5657V26.9876C16.1847 27.921 11.0198 30.3168 9.77524 30.9391C8.31287 31.6547 6.66382 32.9615 6.66382 32.9615V33.3349L2.99236 38.531L2.18338 39.6822L1.37442 39.5888L0.752136 39.8689V40.3356L1.00105 40.7401L0.689904 40.8023L0.347656 41.1446L0.378763 41.549L1.43665 41.8291L1.40553 44.1626H1.12551C1.12551 44.1626 1.03215 45.345 1.18772 45.8739C1.34329 46.3717 1.46775 46.9629 2.18338 47.2429C2.93012 47.523 5.45036 48.4875 5.45036 48.4875L5.85484 48.892H11.5799C11.5799 43.2914 14.629 39.5266 18.5183 38.5621V31.4992Z",
    fill: "url(#paint21_linear_334_30477)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M105.015 48.1764L118.332 46.9629V46.714L104.953 47.7719L105.015 48.1764Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.861 25.992C118.768 24.8096 117.866 16.9689 117.554 14.7909C117.243 12.644 114.816 12.3329 114.816 12.3329L73.7457 12.364C73.7457 12.364 53.8015 12.644 51.8413 12.644C50.13 12.644 50.3478 14.822 50.3478 14.822C50.5034 16.0977 50.5345 20.5781 51.1568 24.3429C51.8102 28.0766 53.3659 28.4189 54.8905 28.4189C56.4151 28.4189 73.7457 28.0144 73.7457 28.0144C73.7457 28.0144 116.963 27.6099 117.803 27.6099C118.737 27.6099 118.955 27.1743 118.861 25.992ZM118.426 27.1432C118.363 27.2054 118.239 27.2988 117.866 27.2988C117.025 27.2988 74.2746 27.7032 73.8079 27.7032C73.5901 27.7032 56.4773 28.1077 54.9527 28.1077C53.4904 28.1077 52.1214 27.8277 51.4991 24.2807C51.0635 21.636 50.9079 18.649 50.7834 16.6577C50.7523 15.8176 50.7212 15.1642 50.659 14.7909C50.659 14.7909 50.5657 13.7952 51.0324 13.2663C51.2191 13.0485 51.4991 12.9551 51.8413 12.9551C53.7704 12.9551 73.4968 12.6751 73.7457 12.6751L114.785 12.644C115.003 12.6751 116.963 13.0174 117.243 14.8531C117.554 17.1244 118.457 24.903 118.55 26.0231C118.612 26.6142 118.55 26.9876 118.426 27.1432Z",
    fill: "url(#paint22_linear_334_30477)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.7251 28.9789C41.9784 28.9789 41.3872 29.5701 41.3872 30.3168C41.3872 31.0636 41.9784 31.6547 42.7251 31.6547C43.4718 31.6547 44.063 31.0636 44.063 30.3168C44.063 29.5701 43.4718 28.9789 42.7251 28.9789ZM42.7251 31.468C42.0717 31.468 41.5428 30.9391 41.5428 30.2857C41.5428 29.6323 42.0717 29.1034 42.7251 29.1034C43.3785 29.1034 43.9074 29.6323 43.9074 30.2857C43.9074 30.9391 43.3785 31.468 42.7251 31.468Z",
    fill: "url(#paint23_linear_334_30477)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M42.7248 31.468C42.0714 31.468 41.5425 30.9391 41.5425 30.2857C41.5425 29.6323 42.0714 29.1034 42.7248 29.1034C43.3782 29.1034 43.9071 29.6323 43.9071 30.2857C43.9071 30.9391 43.3782 31.468 42.7248 31.468Z",
    fill: "url(#paint24_linear_334_30477)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.621 30.9391L124.928 32.2459L124.835 32.557L123.466 31.3125L123.621 30.9391Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.813 7.66573L121.755 7.8213H122.813V7.66573Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.622 11.8661L122.626 12.1151V12.2706L123.653 11.9906L123.622 11.8661Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1938 29.2901L25.612 23.7517C25.612 23.7517 33.1417 15.5998 33.6706 15.1954C34.1995 14.7909 34.9463 14.1686 36.5331 13.8574C38.1199 13.5463 42.4137 13.0796 43.4405 12.9551C44.4672 12.8307 46.2096 12.7685 46.0229 14.6664C45.8362 16.5955 45.3384 20.1425 45.0895 21.5115C44.8406 22.8805 44.6539 25.3697 41.8536 26.1164C39.0534 26.832 27.9767 28.5122 27.9767 28.5122L21.505 29.8501C21.5361 29.8501 20.8827 29.6945 21.1938 29.2901Z",
    fill: "#141C1E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8958 26.5831H20.5093L33.4839 13.1418L31.1193 12.7062V13.0174L17.8958 26.5831Z",
    fill: "#141C1E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5407 26.0853L32.8308 13.3596L31.1195 13.0174L18.5183 25.9608L20.5407 26.0853Z",
    fill: "#98A6AA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M34.7599 15.382L33.5464 26.4587C33.4531 26.9565 33.702 27.2054 34.1998 27.1121C37.2179 26.6142 40.4538 26.0542 41.7917 25.7119C44.0941 25.1208 44.4053 23.2228 44.6542 21.8227C44.6853 21.6982 44.6853 21.5738 44.7164 21.4493C44.9653 20.0492 45.4632 16.471 45.6498 14.6353C45.681 14.1997 45.6187 13.8886 45.4321 13.6708C45.2143 13.453 44.8409 13.3285 44.2497 13.3285C43.9697 13.3285 43.7208 13.3596 43.503 13.3907L43.0985 13.4218C41.6984 13.5774 38.0269 13.9819 36.6267 14.293C36.0045 14.4175 35.5377 14.5731 35.1644 14.7598C35.1644 14.7598 34.791 14.8842 34.7599 15.382Z",
    fill: "#C2CDD0"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M33.7328 15.7554C33.0172 16.4399 30.9326 18.6801 28.8168 20.9515L28.0078 28.0766C28.3501 28.0144 30.3103 27.7344 32.6438 27.361C33.0483 27.2988 33.0483 26.8009 33.0483 26.8009L34.2306 16.1599C34.324 15.2265 33.7328 15.7554 33.7328 15.7554Z",
    fill: "#C2CDD0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5407 26.0853L22.6253 23.9384L21.0074 24.0318L18.6738 25.9609L20.5407 26.0853Z",
    fill: "#303E42"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M33.7327 15.7554C33.0171 16.4399 30.9325 18.6801 28.8167 20.9515L28.6611 22.4138C30.0924 21.6049 31.8348 20.7337 33.8261 19.8936L34.2306 16.191C34.3239 15.2265 33.7327 15.7554 33.7327 15.7554Z",
    fill: "url(#paint25_linear_334_30477)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.2495 13.3285C43.9695 13.3285 43.7205 13.3596 43.5027 13.3907L43.0983 13.4218C41.6982 13.5774 38.0267 13.9819 36.6265 14.293C36.0042 14.4175 35.5375 14.5731 35.1642 14.7598C35.1642 14.7598 34.7908 14.8842 34.7597 15.382L34.293 19.7069C37.56 18.369 41.387 17.2489 45.3696 17.0311C45.4941 16.1288 45.5874 15.2887 45.6496 14.6353C45.6807 14.1997 45.6185 13.8886 45.4318 13.6708C45.214 13.453 44.8095 13.3285 44.2495 13.3285Z",
    fill: "url(#paint26_linear_334_30477)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4304 26.6765L33.1105 26.3342L33.0483 26.8009C33.0483 26.8009 33.0483 27.2676 32.6438 27.361C30.2792 27.7343 28.3501 28.0455 28.0078 28.0766L28.6612 22.2894L32.0215 25.6497L31.3993 26.272L29.8124 24.6852L29.7502 25.0896L29.8747 25.2141L31.4304 26.6765Z",
    fill: "#303E42"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4943 15.9732C45.2765 17.8712 44.9031 20.3292 44.7164 21.4493C44.6853 21.5738 44.6853 21.6982 44.6542 21.8227C44.4364 23.2228 44.0941 25.1208 41.7917 25.7119C40.4538 26.0542 37.2179 26.6142 34.1998 27.1121C33.702 27.2054 33.4531 26.9565 33.5464 26.4587L33.5776 26.272L39.8315 25.0274C40.6405 22.196 41.5739 18.9602 41.9161 18.1512C42.5073 16.6266 43.4096 15.9732 44.9031 15.9421C45.1209 15.911 45.3076 15.9421 45.4943 15.9732Z",
    fill: "#303E42"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74333 34.5172L2.46332 35.544L1.84103 35.9796L1.68546 36.4774H2.15217L1.90326 37.6598L1.28098 38.0954L1.21875 38.4999H1.65434L1.37432 39.62C1.37432 39.62 1.37431 39.62 1.40543 39.62C1.71657 39.62 1.87214 39.3399 1.87214 39.3399C1.87214 39.3399 2.80557 36.3219 3.0856 35.4507C3.33451 34.5484 2.74333 34.5172 2.74333 34.5172Z",
    fill: "#263133"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74342 36.4463C2.83676 36.1041 2.96122 35.7929 3.02345 35.5751L2.4634 35.5129L1.84112 35.9485L1.68555 36.4463H2.15226H2.74342Z",
    fill: "#404B4D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90326 37.6287L1.28098 38.0643L1.21875 38.4687H1.65434H2.12105C2.18328 38.2198 2.27663 37.9398 2.36998 37.6287H1.90326Z",
    fill: "#404B4D"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80957 35.9485H2.86746C2.89857 35.824 2.96081 35.6996 2.99192 35.5751L2.43185 35.5129L1.80957 35.9485Z",
    fill: "#5A6567"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31201 38.0643H2.24544C2.27655 37.9398 2.33879 37.7842 2.3699 37.6287H1.90319L1.31201 38.0643Z",
    fill: "#5A6567"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6494 30.3168C45.6806 30.099 45.5561 29.8812 44.9027 29.9123C44.2493 29.9123 41.0757 30.0057 41.0757 30.0057C41.0757 30.0057 40.7334 30.0368 40.7334 30.3168C40.7334 30.5969 41.0134 30.5969 41.3246 30.5969C41.6668 30.5969 44.0315 30.6591 44.0315 30.6591L44.0937 30.7213H44.965C44.9961 30.7213 45.5872 30.7213 45.6494 30.3168Z",
    fill: "url(#paint27_linear_334_30477)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.6496 30.3168C45.6496 30.2235 45.6495 30.1301 45.5562 30.0679C45.4006 30.5035 44.2183 30.3791 44.2183 30.3791C44.2183 30.3791 41.4803 30.3791 41.1069 30.3168C40.8891 30.2857 40.9202 30.1613 40.9824 30.0368C40.8891 30.0679 40.7646 30.1613 40.7646 30.3168C40.7646 30.5969 41.0446 30.5969 41.3558 30.5969C41.698 30.5969 44.0627 30.6591 44.0627 30.6591L44.125 30.7213H44.9962C44.9962 30.7213 45.5873 30.7213 45.6496 30.3168Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2627 39.7755L88.6491 39.371L28.5366 39.7133L25.7986 40.18C26.9809 41.0823 27.9143 42.2958 28.4744 43.6959L88.2758 43.2914C89.0225 41.7668 90.0493 40.5845 91.2627 39.7755Z",
    fill: "url(#paint28_linear_334_30477)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6491 39.3399L28.4121 39.8378L28.1321 41.1757L89.0536 40.709L88.6491 39.3399Z",
    fill: "#495255"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2512 40.18L12.1087 39.8378L2.05881 40.2111L0.969815 40.7401L0.658673 40.8023L0.316406 41.1446L0.347532 41.549L1.4054 41.8291L1.37429 44.1626H1.09426C1.09426 44.1626 1.00092 45.345 1.15649 45.8739C1.31206 46.3717 1.43652 46.9629 2.15215 47.2429C2.89889 47.523 5.41913 48.4875 5.41913 48.4875L5.82361 48.892H11.5797C11.5797 44.9716 13.0421 41.9846 15.2512 40.18Z",
    fill: "url(#paint29_linear_334_30477)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.2512 40.18L12.1087 39.8378L2.05881 40.2111L0.969815 40.7401L0.658673 40.8023L0.316406 41.1446L0.347532 41.549L1.4054 41.8291L1.37429 44.1626H1.09426C1.09426 44.1626 1.00092 45.345 1.15649 45.8739C1.31206 46.3717 1.43652 46.9629 2.15215 47.2429C2.89889 47.523 5.41913 48.4875 5.41913 48.4875L5.82361 48.892H11.5797C11.5797 44.9716 13.0421 41.9846 15.2512 40.18Z",
    fill: "url(#paint30_linear_334_30477)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.1119 46.4962C3.61407 45.0338 3.70742 41.798 3.70742 41.798H1.43609L1.40496 44.1315H1.12495C1.12495 44.1315 1.03159 45.3138 1.18716 45.8428C1.34273 46.3406 1.46719 46.9318 2.18282 47.2118C2.92956 47.4918 5.4498 48.4564 5.4498 48.4564L5.85428 48.8609H11.5793C11.5793 48.4875 11.6104 48.1141 11.6104 47.7407H5.69871C5.69871 47.7719 4.64084 47.9897 4.1119 46.4962Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99219 41.6113C2.99219 41.6113 4.33009 41.4868 4.33009 41.9535C4.33009 42.4202 4.33009 43.1047 4.33009 43.1047C4.33009 43.1047 4.05006 43.7893 3.70781 43.9759C3.36555 44.1937 2.99219 44.1004 2.99219 43.5092C2.99219 42.8869 2.99219 41.6113 2.99219 41.6113Z",
    fill: "url(#paint31_linear_334_30477)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1399 39.8378L2.09004 40.2111L1.00105 40.7401L0.689904 40.8023L0.347656 41.1446L13.0111 41.0201L12.1399 39.8378Z",
    fill: "#565F62"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53076 46.7762H11.0821L11.0199 46.994L8.53076 46.7762Z",
    fill: "#565F62"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9263 48.5186C11.0818 44.8782 12.3886 41.9846 14.3177 40.0867L13.7576 40.0244C12.0775 41.9846 11.0507 44.9094 10.9263 48.5186Z",
    fill: "url(#paint32_linear_334_30477)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 43.5092L7.13062 43.6648L12.5445 43.8826C12.6067 43.7581 12.6378 43.6337 12.7 43.5092Z",
    fill: "#565F62"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7 43.5092L7.13062 43.6648L12.6378 43.6959C12.6689 43.5715 12.6378 43.6337 12.7 43.5092Z",
    fill: "url(#paint33_linear_334_30477)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M125.426 44.256C125.426 44.256 125.239 45.8428 124.928 46.185C124.617 46.4962 123.652 46.4962 123.652 46.4962L123.528 46.714L118.301 47.3674V42.9181L103.677 43.2603C103.273 42.3891 102.713 41.6113 102.028 40.9267C101.592 40.4912 101.095 40.0867 100.566 39.7444L103.148 39.371L123.435 39.2777H123.901C123.901 39.2777 123.901 39.3399 123.901 39.4333C123.901 39.4644 123.901 39.5266 123.901 39.5577C123.901 39.62 123.901 39.7133 123.901 39.7755C123.901 39.8066 123.901 39.8689 123.901 39.9311C123.901 39.9622 123.901 39.9933 123.901 40.0556C123.901 40.1489 123.901 40.2734 123.901 40.3978C123.901 40.46 123.901 40.4912 123.901 40.5534C123.901 41.0201 123.87 41.5179 123.87 41.9535C123.87 43.0736 124.088 44.0693 124.088 44.0693H124.648H124.959L125.426 44.256Z",
    fill: "url(#paint34_linear_334_30477)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.426 44.256C125.426 44.256 125.239 45.8428 124.928 46.185C124.617 46.4962 123.652 46.4962 123.652 46.4962L123.528 46.714L118.301 47.3674V42.9181L103.677 43.2603C103.273 42.3891 102.713 41.6113 102.028 40.9267C101.592 40.4912 101.095 40.0867 100.566 39.7444L103.148 39.371L123.435 39.2777H123.901C123.901 39.2777 123.901 39.3399 123.901 39.4333C123.901 39.4644 123.901 39.5266 123.901 39.5577C123.901 39.62 123.901 39.7133 123.901 39.7755C123.901 39.8066 123.901 39.8689 123.901 39.9311C123.901 39.9622 123.901 39.9933 123.901 40.0556C123.901 40.1489 123.901 40.2734 123.901 40.3978C123.901 40.46 123.901 40.4912 123.901 40.5534C123.901 41.0201 123.87 41.5179 123.87 41.9535C123.87 43.0736 124.088 44.0693 124.088 44.0693H124.648H124.959L125.426 44.256Z",
    fill: "url(#paint35_linear_334_30477)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M123.964 39.2466C123.964 39.2466 123.964 39.3088 123.964 39.4022C123.964 39.4333 123.964 39.4955 123.964 39.5266C123.964 39.5888 123.964 39.6822 123.964 39.7444C123.964 39.7755 123.964 39.8378 123.964 39.9C123.964 39.9311 123.964 39.9622 123.964 40.0244C123.964 40.1178 123.964 40.2422 123.964 40.3667C123.964 40.4289 123.964 40.46 123.964 40.5223L102.993 40.6156L102.153 40.8956C101.717 40.46 101.219 40.0555 100.69 39.7133L103.273 39.3399L123.559 39.2466H123.964Z",
    fill: "#495255"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.964 39.2466C123.964 39.2466 123.964 39.3088 123.964 39.4022C123.964 39.4333 123.964 39.4955 123.964 39.5266C123.964 39.5888 123.964 39.6822 123.964 39.7444C123.964 39.7755 123.964 39.8378 123.964 39.9C123.964 39.9311 123.964 39.9622 123.964 40.0244C123.964 40.1178 123.964 40.2422 123.964 40.3667C123.964 40.4289 123.964 40.46 123.964 40.5223L102.993 40.6156L102.153 40.8956C101.717 40.46 101.219 40.0555 100.69 39.7133L103.273 39.3399L123.559 39.2466H123.964Z",
    fill: "url(#paint36_linear_334_30477)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.4436 39.7133L26.4834 40.0556C27.6035 41.0201 28.5058 42.2647 29.0347 43.6959H29.5015C29.1592 42.7936 28.7236 41.9535 28.1324 41.2068L28.4436 39.7133Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.406 39.5888C102.651 40.5223 103.646 41.7668 104.3 43.1981H104.549C104.144 42.2647 103.584 41.3935 102.9 40.6467L103.18 39.3088L101.406 39.5888Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.4048 43.2603H87.6537C88.3693 41.7668 89.3339 40.5534 90.5162 39.6511L88.6494 39.3399L89.0539 40.6778C88.4005 41.4246 87.8404 42.2958 87.4048 43.2603Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.902 41.9224C123.902 41.4868 123.901 40.989 123.933 40.5223H122.532L122.595 44.0382H124.088C124.088 44.0382 123.902 43.0114 123.902 41.9224Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.426 44.256L124.929 44.0382H124.617H124.057C124.057 44.0382 124.057 44.0071 124.057 43.9759C123.808 44.5982 123.342 45.5628 122.688 45.625C121.693 45.7183 118.301 46.1539 118.301 46.1539V47.3363L123.528 46.6829L123.653 46.4651C123.653 46.4651 124.617 46.4962 124.929 46.1539C125.24 45.8428 125.426 44.256 125.426 44.256Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.363 42.9803L118.301 42.8247C118.301 42.8247 119.608 42.4202 119.608 41.549C119.608 40.6156 119.67 39.2777 119.67 39.2466H119.826C119.826 39.2466 119.764 40.6156 119.764 41.5179C119.764 42.5136 118.426 42.9492 118.363 42.9803Z",
    fill: "black"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M118.333 45.8739L121.164 45.7806L118.333 46.1228V45.8739Z",
    fill: "#565F62"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M26.141 21.8538L26.5454 21.4804H27.6344C27.6344 21.4804 27.9456 21.4182 28.1012 22.1649C28.2567 22.9117 28.5368 25.4941 28.5368 25.4941V25.7119C28.5368 25.7119 28.6923 27.1121 28.7234 27.3921C28.7546 27.6721 28.6301 28.1077 28.1945 28.1077C27.7589 28.1388 26.7633 28.1077 26.7633 28.1077L26.1099 27.8277V21.8538H26.141Z",
    fill: "url(#paint37_linear_334_30477)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5722 27.6099V25.7742C27.5722 25.7742 27.51 23.5339 27.2922 22.445C27.0744 21.356 26.5766 21.5426 26.5766 21.5426L26.5143 21.4804L26.1099 21.8538V27.8899L26.7633 28.17C26.7633 28.17 26.8877 28.17 27.0744 28.17C27.51 27.8277 27.5722 27.6099 27.5722 27.6099Z",
    fill: "#212A2D"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0122 27.2987C26.9811 27.0498 26.7945 23.5651 26.7322 22.6939C26.67 21.8538 26.2033 21.8227 26.2033 21.8227H26.1722V27.8588C26.1411 27.8899 27.0434 27.5477 27.0122 27.2987Z",
    fill: "#141D20"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5725 25.3075L28.4126 25.2141L27.5725 25.8053V25.3075Z",
    fill: "url(#paint38_linear_334_30477)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62815 32.806L7.56592 32.7748C8.21931 31.9348 11.8597 30.1924 13.3843 29.4767C14.5044 28.9478 20.4161 26.5831 20.4783 26.552L23.5275 26.7076V26.7698L20.4783 26.6142C20.2605 26.7076 14.5044 29.0411 13.3843 29.539C11.8908 30.2546 8.25043 31.9659 7.62815 32.806Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1816 47.6163C31.1816 47.5541 30.6527 44.1937 30.2171 42.918C29.8126 41.6424 28.4125 39.7444 28.3814 39.7133C28.3814 39.6822 26.9501 37.9709 25.3944 37.2242H25.3633V37.1931L25.55 23.7206L25.5811 23.6895C25.5811 23.5339 25.6744 22.2271 26.2967 21.6049C26.9501 20.9515 33.453 14.1064 33.5463 14.0441C33.5774 14.0441 34.7598 13.1418 36.3777 12.8307C38.2445 12.4573 42.8183 11.7106 46.8321 11.7106C46.9876 11.7106 47.1432 11.7106 47.2676 11.7106H47.2988V11.7417L46.7698 33.2416L46.6142 33.6149L46.0542 34.6106L45.8364 41.0201L44.903 46.8384C44.903 46.8384 44.8407 47.3363 44.0006 47.3674C43.1917 47.4296 31.2127 47.6163 31.1816 47.6163ZM25.4566 37.1931C27.0123 37.9709 28.4436 39.6822 28.4436 39.6822C28.4436 39.7133 29.8748 41.6113 30.2793 42.918C30.6838 44.1315 31.1816 47.2429 31.2127 47.5541C31.835 47.5541 43.1606 47.3363 43.9695 47.3363C44.7474 47.3363 44.7785 46.9007 44.8096 46.8695L45.7431 41.0512L45.9608 34.6106L46.5209 33.6149L46.6765 33.2416L47.2054 11.8039C47.081 11.8039 46.9254 11.8039 46.8009 11.8039C42.8183 11.8039 38.2445 12.5195 36.3777 12.924C34.7909 13.2663 33.5774 14.1375 33.5774 14.1375C33.5152 14.1997 26.9812 21.0448 26.3589 21.6982C25.7367 22.3516 25.6433 23.7517 25.6433 23.7517L25.6122 23.7829L25.4566 37.1931Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4808 49.1098L48.3875 34.5484L48.3564 33.4594L48.4808 33.0238L48.2319 3.80758H48.2941L48.5431 33.0549L48.4186 33.4594L48.4808 34.5484L48.5431 49.1098H48.4808Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.981 27.4854L118.985 11.3683V10.9327L118.208 3.34087L118.27 3.30975L119.048 10.9327V11.3683L120.043 27.4854H119.981Z",
    fill: "black"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M124.96 44.0382H124.648V39.1844L124.991 38.531C124.991 38.531 124.897 28.8856 124.897 28.4189C124.897 27.9522 123.995 14.5108 123.559 11.4617C123.186 8.94142 122.377 5.83 121.91 4.49209L120.977 4.67878C120.946 4.70989 120.884 4.89658 120.977 5.30106C121.008 5.3944 121.039 5.51886 121.07 5.67443C121.288 6.54563 121.786 8.35025 122.035 9.87484C122.221 11.0261 122.47 13.7019 122.657 15.8488C122.782 17.0622 122.875 18.1201 122.906 18.4623C123.03 19.458 123.559 27.8588 123.559 28.3566H123.497C123.497 27.8277 122.999 19.458 122.844 18.4623C122.782 18.089 122.688 17.0933 122.595 15.8488C122.408 13.7019 122.159 11.0261 121.973 9.87484C121.724 8.35025 121.257 6.54563 121.008 5.67443C120.977 5.51886 120.946 5.3944 120.915 5.30106C120.79 4.80324 120.915 4.61655 120.915 4.61655L121.848 4.42987C121.755 4.18095 121.692 4.02538 121.63 3.93204C121.568 3.86981 121.475 3.77647 121.319 3.71424L120.043 4.74101C120.292 4.89658 120.51 5.17661 120.572 5.58109C120.821 7.01234 122.47 22.2583 122.782 27.8277C123.03 32.3393 122.875 42.8869 122.813 46.7451L123.497 46.6518L123.622 46.434C123.622 46.434 124.586 46.4651 124.897 46.1228C125.208 45.8117 125.395 44.1937 125.395 44.1937L124.96 44.0382Z",
    fill: "url(#paint39_linear_334_30477)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.639 39.2466L119.919 33.2727V27.4854H122.439C123.093 27.4854 123.653 27.921 123.653 28.6055V30.908L123.466 31.3747L123.715 33.2416V38.6243L123.466 39.2466H119.639Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M120.044 27.6099V30.6591V31.2503V33.2727L119.764 39.1221H123.591L123.777 38.6243V33.2727L123.497 31.3747L123.684 30.8769C123.684 30.8769 123.684 29.1967 123.684 28.6055C123.684 28.0144 123.062 27.6099 122.44 27.6099C121.817 27.6099 120.044 27.6099 120.044 27.6099Z",
    fill: "#B01120"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M123.933 44.5982C123.808 44.5982 123.746 44.6604 123.746 44.8471C123.715 45.0338 123.746 45.5005 123.746 45.6561C123.746 45.8117 123.87 45.8739 124.026 45.8739C124.182 45.905 124.368 45.905 124.462 45.5005C124.555 45.096 124.617 44.7227 124.617 44.7227C124.617 44.7227 124.648 44.5982 124.462 44.5982C124.275 44.6293 123.933 44.5982 123.933 44.5982Z",
    fill: "#B01120"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M123.653 30.9391L123.591 30.8769L123.28 30.7835H120.044V31.2503V33.2727H123.404H123.777L123.497 31.3747L123.653 30.9391Z",
    fill: "url(#paint40_linear_334_30477)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M123.777 35.4818V36.2596H120.603C120.417 36.2596 120.261 36.1974 120.261 36.0729C120.261 35.9485 120.261 35.9485 120.261 35.7929C120.261 35.6373 120.323 35.4818 120.603 35.4818H123.777Z",
    fill: "url(#paint41_linear_334_30477)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M123.777 36.6952V37.4731H120.603C120.417 37.4731 120.261 37.4109 120.261 37.2864C120.261 37.1619 120.261 37.1619 120.261 37.0064C120.261 36.8508 120.323 36.6952 120.603 36.6952H123.777Z",
    fill: "url(#paint42_linear_334_30477)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M119.795 38.531L119.764 39.1221H123.56L123.777 38.5932V38.531H119.795Z",
    fill: "#A30413"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.248 39.1221H123.56L123.746 38.6243V33.2727L123.466 31.3747L123.653 30.8769C123.653 30.8769 123.653 29.1967 123.653 28.6055C123.653 28.2944 123.466 28.0144 123.217 27.8588L123.248 30.7835L123.124 31.3125L123.342 33.2104V38.5932L123.248 39.1221Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.28 30.7835H120.044V31.2503L123.155 31.3125H123.466H123.529L123.653 30.9391L123.591 30.8769L123.28 30.7835Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M120.044 27.6099V30.6591V31.2503V33.2727L119.764 39.1221H123.591L123.777 38.6243V33.2727L123.497 31.3747L123.684 30.8769C123.684 30.8769 123.684 29.1967 123.684 28.6055C123.684 28.0144 123.062 27.6099 122.44 27.6099C121.817 27.6099 120.044 27.6099 120.044 27.6099Z",
    fill: "url(#paint43_linear_334_30477)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.77451 39.0288C2.71228 39.0288 2.65005 38.9977 2.61894 38.9354C2.55671 38.8421 2.58782 38.6865 2.61894 38.6243C3.39679 36.5085 4.05018 34.8906 5.45031 33.5838C6.69488 32.4326 8.46839 32.3081 9.18401 32.3081C9.5885 32.3081 9.96187 32.3392 10.273 32.4015C10.7086 32.4948 10.9575 32.6504 11.0198 32.8371C11.1131 33.1171 10.9264 33.366 10.7086 33.646L10.553 33.8638C10.0863 34.4861 8.904 36.1041 8.12614 36.8819C7.28606 37.7531 6.0726 38.4065 5.51255 38.5621C5.13918 38.6554 3.98796 38.811 3.30345 38.9043C3.05454 38.9354 2.86784 38.9666 2.80561 38.9666C2.80561 39.0288 2.77451 39.0288 2.77451 39.0288Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71234 38.6865C2.71234 38.6865 2.619 38.9354 2.77457 38.9043C2.96126 38.8732 4.95255 38.6243 5.45038 38.4998C5.94821 38.3754 7.16166 37.722 8.00174 36.8508C8.84183 35.9796 10.2109 34.1127 10.5531 33.6772C10.8642 33.2416 11.2376 32.806 10.2108 32.5882C9.18407 32.3704 6.91276 32.4326 5.48151 33.7394C4.11248 35.0151 3.45908 36.6641 2.71234 38.6865Z",
    fill: "url(#paint44_linear_334_30477)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72131 34.9217C7.78354 35.264 7.47241 35.6062 7.03682 35.6685C6.60122 35.7307 6.3834 35.5129 6.32118 35.1706C6.25895 34.8284 6.38342 34.4861 6.81901 34.4239C7.25461 34.3617 7.65908 34.5795 7.72131 34.9217Z",
    fill: "url(#paint45_linear_334_30477)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48116 38.0643C5.48116 38.0643 6.32123 37.5664 6.32123 36.3841C6.32123 35.2017 5.48116 34.9839 5.48116 34.9839C5.48116 34.9839 5.07666 35.3573 5.07666 36.5085C5.07666 37.6909 5.48116 38.0643 5.48116 38.0643Z",
    fill: "url(#paint46_linear_334_30477)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7344 38.531C4.9522 38.6865 5.07665 37.8465 5.07665 37.442C5.07665 37.0375 4.95221 36.4774 4.79664 36.4463C4.60995 36.4152 4.5166 37.0686 4.5166 37.5042C4.5166 37.9087 4.51661 38.4065 4.7344 38.531Z",
    fill: "url(#paint47_linear_334_30477)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2417 32.5882C9.21497 32.3704 6.94363 32.4326 5.51238 33.7394C5.13901 34.0816 4.82788 34.455 4.54785 34.8284C5.85465 34.4861 8.68602 33.7394 10.8329 33.3349C10.9885 32.9926 10.9574 32.7437 10.2417 32.5882Z",
    fill: "url(#paint48_linear_334_30477)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M2.71234 38.6865C2.71234 38.6865 2.619 38.9354 2.77457 38.9043C2.96126 38.8732 4.95255 38.6243 5.45038 38.4998C5.94821 38.3754 7.16166 37.722 8.00174 36.8508C8.84183 35.9796 10.2109 34.1127 10.5531 33.6772C10.8642 33.2416 11.2376 32.806 10.2108 32.5882C9.18407 32.3704 6.91276 32.4326 5.48151 33.7394C4.11248 35.0151 3.45908 36.6641 2.71234 38.6865Z",
    fill: "url(#paint49_linear_334_30477)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9.86859 32.5259C8.74848 32.3704 6.78829 32.557 5.51261 33.7083C4.11248 35.0151 3.45908 36.6641 2.71234 38.6865C2.71234 38.6865 2.619 38.9354 2.77457 38.9043C2.86791 38.8732 3.45908 38.811 4.05024 38.7176C4.6103 37.4731 6.16601 34.3928 9.86859 32.5259Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5085 2.56301H51.9036V3.58978H56.5085V2.56301Z",
    fill: "#586770"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2549 1.87839C57.2549 1.13165 55.917 0.540482 54.268 0.540482C52.6189 0.540482 51.281 1.13165 51.281 1.87839C51.281 2.62513 52.6189 3.2163 54.268 3.2163C55.917 3.2163 57.2549 2.62513 57.2549 1.87839Z",
    fill: "#0F53B9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.7791 1.69182C51.7791 2.18965 52.1836 2.56302 52.6503 2.56302C53.117 2.56302 53.5215 2.15853 53.5215 1.69182C53.5215 1.19399 53.117 0.820625 52.6503 0.820625C52.1524 0.820625 51.7791 1.22511 51.7791 1.69182Z",
    fill: "#5099DA"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.9658 1.69182C51.9658 2.06519 52.2769 2.37633 52.6503 2.37633C53.0237 2.37633 53.3348 2.06519 53.3348 1.69182C53.3348 1.31845 53.0237 1.00731 52.6503 1.00731C52.2769 1.00731 51.9658 1.31845 51.9658 1.69182Z",
    fill: "#5099DA"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M52.0591 1.69182C52.0591 2.00297 52.3391 2.28299 52.6503 2.28299C52.9614 2.28299 53.2414 2.00297 53.2414 1.69182C53.2414 1.38068 52.9614 1.10065 52.6503 1.10065C52.308 1.10065 52.0591 1.38068 52.0591 1.69182Z",
    fill: "#5099DA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1523 1.69182C52.1523 1.97185 52.3701 2.18965 52.6502 2.18965C52.9302 2.18965 53.148 1.97185 53.148 1.69182C53.148 1.41179 52.9302 1.19399 52.6502 1.19399C52.3701 1.19399 52.1523 1.41179 52.1523 1.69182Z",
    fill: "#5099DA"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2771 1.69182C52.2771 1.87851 52.4327 2.06519 52.6505 2.06519C52.8371 2.06519 53.0238 1.90962 53.0238 1.69182C53.0238 1.47402 52.8683 1.31845 52.6505 1.31845C52.4327 1.31845 52.2771 1.50514 52.2771 1.69182Z",
    fill: "#5099DA"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3701 1.69182C52.3701 1.84739 52.4946 1.94074 52.619 1.94074C52.7746 1.94074 52.8679 1.81628 52.8679 1.69182C52.8679 1.56737 52.7435 1.44291 52.619 1.44291C52.4946 1.44291 52.3701 1.56737 52.3701 1.69182Z",
    fill: "#5099DA"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.8906 1.8785C54.8906 2.37633 55.2951 2.7497 55.7618 2.7497C56.2285 2.7497 56.633 2.34522 56.633 1.8785C56.633 1.38068 56.2285 1.00731 55.7618 1.00731C55.2951 1.00731 54.8906 1.38068 54.8906 1.8785Z",
    fill: "#5099DA"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.0776 1.8785C55.0776 2.25187 55.3888 2.56302 55.7621 2.56302C56.1355 2.56302 56.4466 2.25187 56.4466 1.8785C56.4466 1.50513 56.1355 1.19399 55.7621 1.19399C55.3888 1.19399 55.0776 1.50513 55.0776 1.8785Z",
    fill: "#5099DA"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.1704 1.87851C55.1704 2.18965 55.4193 2.46968 55.7616 2.46968C56.0727 2.46968 56.3528 2.18965 56.3528 1.87851C56.3528 1.56736 56.0727 1.28734 55.7616 1.28734C55.4504 1.28734 55.1704 1.53625 55.1704 1.87851Z",
    fill: "#5099DA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2639 1.8785C55.2639 2.15853 55.4817 2.37633 55.7617 2.37633C56.0418 2.37633 56.2596 2.15853 56.2596 1.8785C56.2596 1.59847 56.0418 1.38068 55.7617 1.38068C55.4817 1.38068 55.2639 1.59847 55.2639 1.8785Z",
    fill: "#5099DA"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3884 1.8785C55.3884 2.06519 55.544 2.25187 55.7618 2.25187C55.9485 2.25187 56.1351 2.0963 56.1351 1.8785C56.1351 1.66071 55.9796 1.50513 55.7618 1.50513C55.5751 1.50513 55.3884 1.66071 55.3884 1.8785Z",
    fill: "#5099DA"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5129 1.87851C55.5129 2.03408 55.6374 2.12742 55.7619 2.12742C55.9174 2.12742 56.0108 2.00296 56.0108 1.87851C56.0108 1.72294 55.8863 1.62959 55.7619 1.62959C55.6063 1.59848 55.5129 1.72294 55.5129 1.87851Z",
    fill: "#5099DA"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.0549 1.94073C53.0549 2.71859 53.6772 3.34087 54.4551 3.34087C55.2329 3.34087 55.8552 2.71859 55.8552 1.94073C55.8552 1.16288 55.2329 0.540595 54.4551 0.540595C53.6772 0.509481 53.0549 1.16288 53.0549 1.94073Z",
    fill: "#5099DA"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.3657 1.94074C53.3657 2.5319 53.8635 3.02973 54.4547 3.02973C55.0459 3.02973 55.5437 2.5319 55.5437 1.94074C55.5437 1.31845 55.0459 0.85174 54.4547 0.85174C53.8635 0.820626 53.3657 1.31845 53.3657 1.94074Z",
    fill: "#5099DA"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.5215 1.94073C53.5215 2.46967 53.9571 2.90527 54.486 2.90527C55.015 2.90527 55.4505 2.46967 55.4505 1.94073C55.4505 1.41179 55.015 0.976196 54.486 0.976196C53.926 0.976196 53.5215 1.41179 53.5215 1.94073Z",
    fill: "#5099DA"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6455 1.94073C53.6455 2.37632 54.0189 2.74969 54.4545 2.74969C54.8901 2.74969 55.2635 2.37632 55.2635 1.94073C55.2635 1.50513 54.8901 1.13176 54.4545 1.13176C54.0189 1.13176 53.6455 1.47401 53.6455 1.94073Z",
    fill: "#5099DA"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8638 1.94073C53.8638 2.25187 54.1438 2.5319 54.4549 2.5319C54.7661 2.5319 55.0461 2.25187 55.0461 1.94073C55.0461 1.59848 54.7661 1.34956 54.4549 1.34956C54.1438 1.34956 53.8638 1.59848 53.8638 1.94073Z",
    fill: "#5099DA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0508 1.94073C54.0508 2.15853 54.2375 2.37633 54.4864 2.37633C54.7042 2.37633 54.922 2.18965 54.922 1.94073C54.922 1.69182 54.7353 1.50513 54.4864 1.50513C54.2375 1.50513 54.0508 1.69182 54.0508 1.94073Z",
    fill: "#5099DA"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M116.061 2.9675C116.061 3.06084 115.999 3.15418 115.905 3.15418H114.287C114.194 3.15418 114.101 3.06084 114.132 2.9675L114.287 1.13176C114.287 1.03842 114.381 0.945076 114.474 0.945076H115.719C115.812 0.945076 115.905 1.03842 115.905 1.13176L116.061 2.9675Z",
    fill: "#0F53B9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M116.186 3.02972H113.945V3.46532H116.186V3.02972Z",
    fill: "#586770"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.225 1.81627C114.225 2.28298 114.598 2.65635 115.065 2.65635C115.532 2.65635 115.905 2.28298 115.905 1.81627C115.905 1.34956 115.532 0.976189 115.065 0.976189C114.598 0.976189 114.225 1.34956 114.225 1.81627Z",
    fill: "#5099DA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.412 1.81627C114.412 2.18964 114.723 2.46967 115.065 2.46967C115.438 2.46967 115.718 2.15852 115.718 1.81627C115.718 1.4429 115.407 1.16287 115.065 1.16287C114.692 1.16287 114.412 1.4429 114.412 1.81627Z",
    fill: "#5099DA"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.505 1.81627C114.505 2.12741 114.754 2.37633 115.065 2.37633C115.376 2.37633 115.625 2.12741 115.625 1.81627C115.625 1.50513 115.376 1.25622 115.065 1.25622C114.754 1.25622 114.505 1.50513 114.505 1.81627Z",
    fill: "#5099DA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M114.567 1.81627C114.567 2.0963 114.785 2.3141 115.065 2.3141C115.345 2.3141 115.563 2.0963 115.563 1.81627C115.563 1.53624 115.345 1.31844 115.065 1.31844C114.785 1.31844 114.567 1.53624 114.567 1.81627Z",
    fill: "#5099DA"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M114.723 1.81627C114.723 2.00295 114.879 2.15853 115.065 2.15853C115.252 2.15853 115.408 2.00295 115.408 1.81627C115.408 1.62958 115.252 1.47401 115.065 1.47401C114.879 1.47401 114.723 1.62958 114.723 1.81627Z",
    fill: "#5099DA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M114.816 1.81627C114.816 1.97184 114.94 2.06519 115.065 2.06519C115.22 2.06519 115.314 1.94073 115.314 1.81627C115.314 1.6607 115.189 1.56736 115.065 1.56736C114.94 1.56736 114.816 1.69182 114.816 1.81627Z",
    fill: "#5099DA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.288 2.59413C114.288 3.09195 114.692 3.46532 115.159 3.46532C115.626 3.46532 116.03 3.06084 116.03 2.59413C116.03 2.0963 115.626 1.72293 115.159 1.72293C114.692 1.72293 114.288 2.0963 114.288 2.59413Z",
    fill: "#5099DA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.505 2.59412C114.505 2.96749 114.816 3.27864 115.19 3.27864C115.563 3.27864 115.874 2.96749 115.874 2.59412C115.874 2.22076 115.563 1.90961 115.19 1.90961C114.785 1.90961 114.505 2.22076 114.505 2.59412Z",
    fill: "#5099DA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M114.599 2.59413C114.599 2.90527 114.879 3.1853 115.19 3.1853C115.501 3.1853 115.781 2.90527 115.781 2.59413C115.781 2.28299 115.501 2.00296 115.19 2.00296C114.848 2.00296 114.599 2.25187 114.599 2.59413Z",
    fill: "#5099DA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M114.661 2.59412C114.661 2.87415 114.878 3.09195 115.158 3.09195C115.438 3.09195 115.656 2.87415 115.656 2.59412C115.656 2.3141 115.438 2.0963 115.158 2.0963C114.91 2.0963 114.661 2.3141 114.661 2.59412Z",
    fill: "#5099DA"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M114.816 2.59413C114.816 2.78081 114.972 2.9675 115.19 2.9675C115.376 2.9675 115.563 2.81192 115.563 2.59413C115.563 2.37633 115.408 2.22076 115.19 2.22076C114.972 2.22076 114.816 2.37633 114.816 2.59413Z",
    fill: "#5099DA"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M114.909 2.59413C114.909 2.7497 115.034 2.84304 115.158 2.84304C115.314 2.84304 115.407 2.71859 115.407 2.59413C115.407 2.43856 115.283 2.34522 115.158 2.34522C115.034 2.3141 114.909 2.43856 114.909 2.59413Z",
    fill: "#5099DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_30477",
    x1: 20.1092,
    y1: 39.7304,
    x2: 20.7582,
    y2: 54.8013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_30477",
    x1: 20.425,
    y1: 52.0322,
    x2: 20.425,
    y2: 41.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_334_30477",
    x1: 20.4246,
    y1: 51.5785,
    x2: 20.4246,
    y2: 42.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_334_30477",
    x1: 20.4251,
    y1: 42.7887,
    x2: 20.4251,
    y2: 51.2382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_334_30477",
    x1: 20.4247,
    y1: 43.4882,
    x2: 20.4247,
    y2: 53.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_334_30477",
    x1: 20.4251,
    y1: 48.7994,
    x2: 20.4251,
    y2: 45.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_334_30477",
    x1: 20.4244,
    y1: 44.417,
    x2: 20.4244,
    y2: 51.9021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_334_30477",
    x1: 20.4246,
    y1: 46.3457,
    x2: 20.4246,
    y2: 47.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_334_30477",
    x1: 20.4249,
    y1: 46.1458,
    x2: 20.4249,
    y2: 48.7265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_334_30477",
    x1: 95.62,
    y1: 39.7304,
    x2: 96.2691,
    y2: 54.8013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_334_30477",
    x1: 95.936,
    y1: 52.0322,
    x2: 95.936,
    y2: 41.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_334_30477",
    x1: 95.935,
    y1: 51.5785,
    x2: 95.935,
    y2: 42.5304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_334_30477",
    x1: 95.9357,
    y1: 42.7887,
    x2: 95.9357,
    y2: 51.2382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_334_30477",
    x1: 95.9356,
    y1: 43.4882,
    x2: 95.9356,
    y2: 53.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_334_30477",
    x1: 95.9355,
    y1: 48.7994,
    x2: 95.9355,
    y2: 45.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_334_30477",
    x1: 95.9352,
    y1: 44.417,
    x2: 95.9352,
    y2: 51.9021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_334_30477",
    x1: 95.9353,
    y1: 46.3457,
    x2: 95.9353,
    y2: 47.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_334_30477",
    x1: 95.9358,
    y1: 46.1458,
    x2: 95.9358,
    y2: 48.7265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76797A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_334_30477",
    x1: 14.2329,
    y1: 26.8598,
    x2: 2.53202,
    y2: 38.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_334_30477",
    x1: 44.6693,
    y1: 5.8038,
    x2: 33.5319,
    y2: 15.6026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_334_30477",
    x1: 34.0836,
    y1: 20.5233,
    x2: 36.7878,
    y2: 16.9032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_334_30477",
    x1: 18.2725,
    y1: 37.937,
    x2: -3.09288,
    y2: 37.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_334_30477",
    x1: 84.6218,
    y1: 23.157,
    x2: 84.6218,
    y2: 11.4013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_334_30477",
    x1: 42.728,
    y1: 31.605,
    x2: 42.728,
    y2: 28.9085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_334_30477",
    x1: 42.7276,
    y1: 31.8939,
    x2: 42.7276,
    y2: 28.0926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_334_30477",
    x1: 30.3939,
    y1: 15.7929,
    x2: 32.5175,
    y2: 22.5968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_334_30477",
    x1: 38.7819,
    y1: 13.1751,
    x2: 40.9055,
    y2: 19.9791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_334_30477",
    x1: 43.1903,
    y1: 29.9074,
    x2: 43.1903,
    y2: 32.8772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1021,
    stopColor: "#3B4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3459,
    stopColor: "#374043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6076,
    stopColor: "#2A3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8767,
    stopColor: "#141D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_334_30477",
    x1: 58.5401,
    y1: 36.121,
    x2: 58.5401,
    y2: 45.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_334_30477",
    x1: 7.80004,
    y1: 40.1394,
    x2: 7.80004,
    y2: 49.4243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151E21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_334_30477",
    x1: 9.08219,
    y1: 44.3595,
    x2: 1.17796,
    y2: 44.3595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_334_30477",
    x1: 3.65999,
    y1: 44.079,
    x2: 3.65999,
    y2: 41.1213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00542935,
    stopColor: "#2F383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0705295,
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1196,
    stopColor: "#727E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    stopColor: "#4A5255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8019,
    stopColor: "#151A1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_334_30477",
    x1: 14.4604,
    y1: 38.7699,
    x2: 10.6538,
    y2: 47.6284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_334_30477",
    x1: 7.12343,
    y1: 43.6046,
    x2: 12.699,
    y2: 43.6046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_334_30477",
    x1: 113.041,
    y1: 36.2463,
    x2: 113.041,
    y2: 48.9005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_334_30477",
    x1: 118.915,
    y1: 43.2824,
    x2: 124.542,
    y2: 43.2824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_334_30477",
    x1: 120.769,
    y1: 40.0655,
    x2: 123.846,
    y2: 40.0655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_334_30477",
    x1: 25.9357,
    y1: 21.5619,
    x2: 27.379,
    y2: 25.7146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_334_30477",
    x1: 27.9878,
    y1: 25.1353,
    x2: 27.9878,
    y2: 27.3785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222B2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_334_30477",
    x1: 112.599,
    y1: 9.22456,
    x2: 113.445,
    y2: 10.6333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_334_30477",
    x1: 121.908,
    y1: 28.6692,
    x2: 121.908,
    y2: 34.3757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00399736,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255007,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0509019,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0823299,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1264,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2488,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_334_30477",
    x1: 122.019,
    y1: 34.3111,
    x2: 122.019,
    y2: 38.4137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00399736,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255007,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0509019,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0823299,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1264,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2488,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_334_30477",
    x1: 122.019,
    y1: 35.5195,
    x2: 122.019,
    y2: 39.6347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00399736,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255007,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0509019,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0823299,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1264,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2488,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_334_30477",
    x1: 119.755,
    y1: 33.3571,
    x2: 123.772,
    y2: 33.3571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_334_30477",
    x1: 6.70068,
    y1: 35.7041,
    x2: 7.46045,
    y2: 37.2442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706E73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49484B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_334_30477",
    x1: 7.00799,
    y1: 34.3699,
    x2: 7.00799,
    y2: 35.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00399736,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255007,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0509019,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0823299,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1264,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2488,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7706,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_334_30477",
    x1: 5.70187,
    y1: 35.0004,
    x2: 5.70187,
    y2: 38.0996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00399736,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255007,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0509019,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0823299,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1264,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2488,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7706,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_334_30477",
    x1: 4.78804,
    y1: 36.328,
    x2: 4.78804,
    y2: 38.5945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00399736,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255007,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0509019,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0823299,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1264,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2488,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7706,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_334_30477",
    x1: 4.55809,
    y1: 33.635,
    x2: 10.9111,
    y2: 33.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00399736,
    stopColor: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0255007,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0509019,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0823299,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1264,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2488,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5577,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7206,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7706,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_334_30477",
    x1: 4.61441,
    y1: 35.6923,
    x2: 10.1045,
    y2: 35.6923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonEmergencyService);
export default __webpack_public_path__ + "static/media/non_emergency_service.64329123c90d06c3bd4b7e71a7dd1507.svg";
export { ForwardRef as ReactComponent };